const env = import.meta.env

export const config = {
	appVersion: env.VITE_APP_VERSION,
	auth0Domain: env.VITE_AUTH0_DOMAIN,
	auth0ClientId: env.VITE_AUTH0_CLIENT_ID,
	auth0Audience: env.VITE_AUTH0_AUDIENCE,
	medBillingHost: env.VITE_MED_BILLING_HOST,
	// Technical product id required by POST /v1/payment-method/change — med-billing-engine
	// validates against a single hardcoded id per environment (400 "Unsupported Product ID"
	// for anything else), so the value is env-specific, not invented here.
	billingChangeProductId: env.VITE_BILLING_CHANGE_PRODUCT_ID,
	medUsersHost: env.VITE_MED_USERS_HOST,
	// med-orders (Orders section, KOVA-797). No staging host: staging builds with the dev backends.
	medOrdersHost: env.VITE_MED_ORDERS_HOST,
	// Sentry/GlitchTip DSN. Empty → Sentry init is a no-op (see src/sentry/init.ts).
	sentryDsn: env.VITE_SENTRY_DSN,
} as const

/** Where support mail goes — every "Contact support" (and, for now, "Contact clinician"). Not per environment. */
export const SUPPORT_EMAIL = 'support@trykova.com'
